import React from 'react'
import type { FC, SVGAttributes } from 'react'

import { useTheme } from '../../../../../core/theme/theme'

export type IconArrowsProps = SVGAttributes<SVGSVGElement>

export const IconArrows: FC<IconArrowsProps> = (props) => {
  const { theme } = useTheme()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke={theme.fg.NEED_PERFORMANCE_REVIEW_mid.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      {...props}
    >
      <path d="M8.6 3.4L5 7l3.6 3.6M19 7H5m10.4 13.6L19 17l-3.6-3.6M5 17h14" />
    </svg>
  )
}
